<template>
  <v-dialog v-model="isVisible" width="600" persistent>
    <v-app-bar class="headline font-weight-bold">
      {{ getItemProductName(menuItem) }}
    </v-app-bar>
    <v-card>
      <v-img class="white--text align-end" max-height="200" :src="getMenuImgSrc(menuItem.productMedia)" contain>
      </v-img>
      <v-card-text>
        <p class="font-weight-bold">{{ menuItem.productIntroducing }}</p>
        <span class="title font-weight-bold primary--text">{{ labels.price[language] }}:${{ menuItem.productPrice
          }}</span>
      </v-card-text>
      <v-divider></v-divider>
      <!--      <v-card-title class="title">{{ labels.remark[language] }}</v-card-title>-->
      <v-container fluid>
        <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
          <v-tab class="title" v-for="(items, itemTypeName) in additionalByType" :key="`tab-${itemTypeName}`">
            {{ itemTypeName }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(items, itemTypeName) in additionalByType" :key="`tabItems-${itemTypeName}`">
            <v-container fluid>
              <p class="primary--text" style="margin-top:8px;margin-bottom:8px;">{{ limitText(items[0].productTypeId) }}
              </p>
              <v-row v-for="item of items" :key="item.productId">
                <v-checkbox v-model="additionalSelected" :label="`${getAdditionalName(item)}`" :value="item"
                  :disabled="handleLimit(item)" class="shrink checkbox-large" color="primary" hide-details></v-checkbox>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
      <v-card-actions>
        <v-container fluid>
          <v-row class="pa-0" dense>
            <v-col>
              <v-btn class="mx-2" rounded dark outlined color="primary" @click="itemCount = Math.max(1, itemCount - 1)">
                <v-icon dark>
                  mdi-minus
                </v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center grey lighten-3 rounded">
              <h2 color="primary" outlined>{{ itemCount }}</h2>
            </v-col>
            <v-col>
              <v-btn class="mx-2" dark rounded color="primary" plain @click="itemCount++">
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="pt-3 justify-center" color="primary">
            <h3 class="text--primary" color="primary">
              {{ labels.count[language] }}
            </h3>
          </v-row>
        </v-container>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container>
          <p class="red--text">{{ errorMessage }}</p>
          <v-row class="pa-0">
            <v-col class="pr-0 pl-0">
              <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="close" block outlined>{{
                labels.cancel[language] }}
              </v-btn>
            </v-col>
            <v-col class="pr-0 pl-0">
              <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="selectItem" block depressed>{{
                labels.add[language] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultAdditionalObj = {
  additionalOfProduct1: null,
  additionalOfProduct2: null,
  additionalOfProduct3: null,
  additionalOfProduct4: null,
  additionalOfProduct5: null,
};
export default {
  name: 'MenuDialog',
  props: ['dialog', 'menuItem'],
  data() {
    return {
      labels: {
        price: {
          en_US: 'PRICE',
          zh_TW: '售價',
        },
        remark: {
          en_US: 'REMARK',
          zh_TW: '註記',
        },
        cancel: {
          en_US: 'CANCEL',
          zh_TW: '取消',
        },
        add: {
          en_US: 'ADD',
          zh_TW: '確定',
        },
        count: {
          en_US: 'COUNT',
          zh_TW: '數量',
        },
      },
      isVisible: false,
      itemSelected: [],
      additionalSelected: [],
      tab: 0,
      itemCount: 1,
      productTypeInfoById: this.$store.getters.productTypeInfoById,
      errorMessage: '',
    };
  },
  methods: {
    limitText(id) {
      const item = this.productTypeInfoById[id];
      const min = item.ueMinAdditionalItem || '';
      const max = item.ueMaxAdditionalItem || '';
      let result = '';
      if (min !== '' && max !== '') {
        result = `最少 ${min} 項 、 最多 ${max} 項`;
      }
      return result;
    },
    handleLimit(item) {
      const { productTypeId } = item;
      const max = Number(this.productTypeInfoById[productTypeId].ueMaxAdditionalItem) || '';
      const selectedArr = this.additionalSelected.filter((item) => item.productTypeId === productTypeId);
      if (max.length === 0) return false;
      if (selectedArr.length >= max && !selectedArr.includes(item)) return true;
      return false;
    },
    close() {
      this.isVisible = false;
      this.$emit('onDialogClose', this.itemSelected);
    },
    getMenuImgSrc(productMedia) {
      try {
        return (productMedia && productMedia.url) ? `${productMedia.url}/${productMedia.file_name}` : '';
      } catch {
        return '';
      }
    },
    getItemProductName(item) {
      return (this.language === 'en_US') ? item.productEnglishName : item.productName;
    },
    getAdditionalName(item) {
      let result = '';
      if (item.productName) {
        result = (this.language === 'en_US') ? item.productEnglishName : item.productName;
        if (item.productPrice) {
          result += `: +$${item.productPrice}`;
        }
      }
      return result;
    },
    selectItem() {
      const additional = {};
      this.menuItem.additional.forEach((item) => {
        const id = item.productTypeId;
        if (!additional[id]) {
          additional[id] = {
            productTypeName: this.productTypeInfoById[id].productTypeName,
            max: Number(this.productTypeInfoById[id].ueMaxAdditionalItem) || '',
            min: Number(this.productTypeInfoById[id].ueMinAdditionalItem) || '',
            count: 0,
          };
        }
      });
      this.additionalSelected.forEach((item) => {
        const id = item.productTypeId;
        if (additional[id]) additional[id].count += 1;
      });
      const errArr = [];
      Object.keys(additional).forEach((key) => {
        const item = additional[key];
        if (item.max !== '' && item.min !== '') {
          if (item.count < item.min) errArr.push(`${item.productTypeName} 最少 ${item.min} 項`);
          if (item.count > item.max) errArr.push(`${item.productTypeName} 最多 ${item.max} 項`);
        }
      });
      if (errArr.length > 0) {
        this.errorMessage = errArr.join(' 、 ');
        return;
      }
      // 整理註記項目
      const transformObj = { ...defaultAdditionalObj };
      Object.keys(this.selectedAdditionalByType)
        .forEach((type, index) => {
          if (index < 5) {
            transformObj[`additionalOfProduct${index + 1}`] = this.selectedAdditionalByType[type];
          }
        });
      for (let i = 0; i < this.itemCount; i += 1) {
        this.itemSelected.push({
          ...this.menuItem,
          ...transformObj,
        });
      }
      this.close();
    },
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    additionalByType() {
      const _type = {};
      if (this.menuItem.additional) {
        this.menuItem.additional.forEach((item) => {
          const _englishName = this.productTypeInfoById[item.productTypeId].productTypeEnglishName;
          const _name = (this.language === 'en_US') ? _englishName : item.productTypeName;
          if (!_type[_name]) _type[_name] = [];
          _type[_name].push(item);
        });
      }
      return _type;
    },
    selectedAdditionalByType() {
      const selectedObj = {};
      this.additionalSelected.forEach((selected) => {
        if (!selectedObj[selected.productTypeId]) {
          selectedObj[selected.productTypeId] = {
            productTypeId: selected.productTypeId,
            productTypeName: selected.productTypeName,
            productTypeEnglishName: selected.productTypeEnglishName,
            products: [],
          };
        }
        selectedObj[selected.productTypeId].products.push(selected);
      });
      return selectedObj;
    },
  },
  watch: {
    dialog(val) {
      this.isVisible = val;
      if (val) {
        this.itemSelected = []; // reset
        this.additionalSelected = []; // reset
        this.tab = 0;
        this.itemCount = 1;
      }
    },
  },
};
</script>

<style>
.checkbox-large .v-icon.v-icon {
  font-size: 1.5em;
}

.checkbox-large .v-label {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
